import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TourPageComponent } from './detail/tour/tour.component';
import { ComponentsModule } from 'app/main/components/components.module';
import { ShoppingCartPageComponent } from './cart/shopping-cart/shopping-cart.component';
import { TripPackageShoppingCartPageComponent }  from './cart/shopping-cart/trip_packages_shopping_cart/shopping-cart.component';
import { CheckoutComponent } from 'app/main/pages/cart/checkout/checkout.component';
import { ThankYouComponent } from './thankyou/thankyou.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { HomeComponent } from './home/home.component';
import { CategoryPageComponent } from './category/category.component';
import { ListProductsPageComponent } from './list-products/list-products.page';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { DetailPageComponent } from './detail/detail.component';
import { ProductPageComponent } from './detail/product/product.component';
import { ProductShoppingCartPageComponent } from './cart/shopping-cart/product_shopping_cart/shopping-cart.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader{
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [
		DetailPageComponent,
		TourPageComponent,
		ProductPageComponent,
		CategoryPageComponent,
		ListProductsPageComponent,
		ShoppingCartPageComponent,
		TripPackageShoppingCartPageComponent,
		ProductShoppingCartPageComponent,
		CheckoutComponent,
		ThankYouComponent,
		NotFoundComponent,
		HomeComponent,
	],
	imports: [
		CommonModule,
		ComponentsModule,
		RouterModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			},
			defaultLanguage: 'it',
		})
	],
	exports: [CommonModule, ComponentsModule, NotFoundComponent],
	providers: []
})
export class PageModule { }
